module.exports = __webpack_public_path__ + "img/tomato.52a13906.png";